<template>
  <md-list-item v-if="!completed">
    <div class="md-list-text-container">
      <span>{{name}}</span>
      <span>{{desc}}</span>
      <md-progress :md-progress="progress" v-show="!hasError && areaStarted"></md-progress>
      <div>
      <md-button v-if="hasError" v-show="hasError" class="md-accent md-raised" @click="startProcess">Tentar Novamente</md-button>
      <md-button v-if="hasError" v-show="hasError" class="md-warn md-raised" @click="openErrorDialog">RESOLVER ERRO</md-button>
      </div>
      <sync-error-dialog v-on:restart="restart" v-if="hasError" v-show="hasError" :error="error" :photoErrors="photoIndexErrors" ref="syncErrorDialog"></sync-error-dialog>
    </div>
  </md-list-item>
</template>
<script>
import SyncErrorDialog from '@/components/SyncErrorDialog'
import { mapState, mapActions } from 'vuex'
export default {
  components: {SyncErrorDialog},
  name: 'StructureSyncItem',
  props: {
    id: Number,
    year: Number,
    itemId: String,
    areaId: Number,
    name: String,
    photos: Array,
    status: Number,
    type: String,
    areaStarted: Boolean
  },
  watch: {
    areaStarted: function(newValue, oldValue) {
      if (newValue === true) {
        this.startProcess()
      }
    }
  },
  computed: {
    ...mapState({
      'uid': state => state.uid,
      'blh': state => state.blh
    }),
    progress () {
      return (this.uploaded / this.photos.length) * 100
    },
    desc () {
      if (!this.completed) {
        if (!this.hasError) {
          return `${this.uploaded} de ${this.photos.length} imagens enviadas`
        } else {
          return 'Ocorreu um erro ao efetuar o upload'
        }
      } else {
        return 'Imagens sincronizadas com sucesso'
      }
    }
  },
  data () {
    return {
      uploaded: 0,
      completed: false,
      uploadStatus: '',
      hasError: false,
      error: '',
      photoIndexErrors: []
    }
  },
  methods: {
    ...mapActions([
      'FETCH_IMAGE',
      'STRUCTURE_SYNC',
      'PHOTO_SYNC',
      'UPLOAD_FILE'
    ]),
    restart() {
      this.startProcess()
    },
    openErrorDialog () {
      this.$refs.syncErrorDialog.openDialog()
    },
    startProcess() {
      this.completed = false
      this.hasError = false
      this.error = ''
      this.photoIndexErrors = []
      this.uploadPhotos()
        .then(() => {
          console.log('[uploadPhotos] END SUCCESS')
          this.completed = true
          this.$emit('structureSynced', this.itemId)
          this.STRUCTURE_SYNC({
            areaId: this.areaId,
            itemId: this.id,
            type: this.type,
            status: 2
          }).then(() => {
            this.$emit('structureSynced', this.itemId)
          })
        })
        .catch((err) => {
          console.log('[uploadPhotos] END WITH ERROR')
          console.log(this.photoIndexErrors)
          this.error = err
        })
    },
    uploadPhotos () {
      var vm = this
      console.log('[uploadPhotos] START')
      console.log(this.photos)
      return Promise.all(
        this.photos.map(function(photo, photoIndex) {
          console.log(`Processing Image ${photoIndex} ${vm.name}`)
          if (photo.status === 2) {
            return Promise.resolve()
          }
          return vm.FETCH_IMAGE(photo.image).then(imgBlob => {
            console.log(`FETCH_IMAGE ${photoIndex} ${vm.name}`)
            let fileName = `${vm.blh.currentYear}_${vm.uid}_${photo.image}.png`
            return vm.UPLOAD_FILE({image: new File([imgBlob], fileName), name: fileName}).then((fileUrl) => {
              return vm.PHOTO_SYNC({photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: 2, image: photo.image, url: fileUrl}).then(() => {
                vm.uploaded++
              })
            }).catch((err) => {
              vm.hasError = true
              return vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: -1 }).then(() => {
                return Promise.reject(err)
              })
            })
          }).catch((err) => {
            vm.hasError = true
            let photoError = {name: vm.name, photo: photo, photoId: photoIndex, areaId: vm.areaId, id: vm.id, itemId: vm.itemId, type: vm.type}
            vm.photoIndexErrors.push(photoError)
            return Promise.reject(err)
          })
        })
      )
      // return Promise.all(this.photos.map(function (photo, photoIndex) {
        // if (!photo.status || photo.status !== 2) {
        // if (!photo.status) {
          // return vm.FETCH_IMAGE(photo.image).then(imgBlob => {
            // return new Promise((resolve, reject) => {
            //   var fr = new FileReader()
            //   fr.onload = () => {
            //     var base64 = fr.result.split('base64,')[1]
            //     vm.UPLOAD_FILE({base64: base64, name: `${vm.blh.currentYear}_${vm.uid}_${photo.image}.png`}).then(() => {
            //       vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: 2, image: photo.image })
            //     }).catch(err => {
            //       vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: -1 })
            //       console.log(err)
            //     })
            //     resolve()
            //   }
            //   fr.readAsDataURL(imgBlob)
            // })
            /*
            let task = storage.child(`${vm.blh.currentYear}/${vm.uid}/${photo.image}`).put(imgBlob)
            task.on('state_changed', null, function (err) {
              console.log(vm.id)
              vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: -1 })
              Promise.reject(err)
            }, function () {
              console.log(vm.id)
              vm.PHOTO_SYNC({ photoId: photoIndex, areaId: vm.areaId, itemId: vm.id, type: vm.type, status: 2, image: photo.image })
              vm.uploaded++
            })
            return task
            */
          // })
        // } else {
          // return Promise.resolve()
        // }
      // }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// StructureSyncItem.vue?1a95129a